import { getCallable } from "../../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import type {
    GetWorkspaceStripeDataRequest,
    GetWorkspaceStripeDataResponse
} from "./types";

export { apiName };

const getWorkspaceStripeData = getCallable<GetWorkspaceStripeDataRequest, GetWorkspaceStripeDataResponse>(
    apiName,
    "getWorkspaceStripeData",
    {
        ...endpoints.getWorkspaceStripeData,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/stripe`,
                options: {
                    method: "GET"
                }
            };
        }
    });

export const callables = {
    getWorkspaceStripeData
};
